<template>
  <div>
    <header class="header" @click="navigateToTitle">
      <img src="@/assets/header.png" alt="AIマップ編集ツールのヘッダー" />
    </header>
    <div class="map-container">
      <div id="ZMap" :class="{ hidden: !isMapVisible }" ref="mapContainer"></div>
    </div>
    <!-- 規約 -->
    <div class="copyright">
      <span><a :href="`/design_map_ai/termsOfUse`" target="_blank" rel="noopener noreferrer">利用規約</a></span>
      <span><a :href="`/design_map_ai/externalTransmissionPolicy`" target="_blank" rel="noopener noreferrer">外部送信ポリシー</a></span>
    </div>
    <!-- <Loading :isVisible="isLoading" /> -->
    <Loading :isVisible="isLoading" :fullScreen="true"/>
  </div>
</template>

<script>
import config from '@/config'
import Map from './zips-map.js'
import axios from 'axios'
import Loading from '@/components/Loading.vue'

export default {
  name: 'MapShare',
  components: {
    Loading
  },
  data () {
    return {
      map: null,
      mapType: null,
      centerLat: null,
      centerLng: null,
      currentZoomLevel: null,
      zoom: null,
      center: null,
      lat: null,
      lng: null,
      mapStyle: null,
      isLoading: true,
      isMapVisible: false
    }
  },
  async mounted () {
    await this.getMap()
    this.isLoading = false
    this.$nextTick(() => {
      setTimeout(() => {
        this.isMapVisible = true
      }, 300)
    })
  },
  methods: {
    /**
     * 地図を描画する
     */
    async drawMap () {
      await this.$loadScript(
        'https://' + config.zipsApi.domain + '/zma_loader.js?key=' + config.zipsApi.key + '&auth=' + config.zipsApi.authType
      )
      this.map = new Map('ZMap', 'kP8KjZdn', this.zoom, this.lat, this.lng, false, false)
      this.map.setMapCenterListener((centerLat, centerLng) => {
        this.centerLat = centerLat
        this.centerLng = centerLng
      })
      this.map.setMapZoomListener((zoomLevel) => {
        this.currentZoomLevel = zoomLevel
      })
      await this.map.initMap()

      // this.map.removeZoomButton()
      if (this.mapType === 'white') {
        this.map.setWhiteMap()
      } else if (this.mapType === 'gmap') {
        this.map.setGoogleMap()
      } else if (this.mapType === 'white_kids') {
        this.map.setWhiteKidsMap()
      } else if (this.mapType === 'gmap_kids') {
        this.map.setGoogleMapKids()
      }
      if (Object.keys(this.mapStyle).length !== 0) {
        this.map.updateStyleMap(this.mapStyle)
      }
    },
    async getMap () {
      const response = await axios.get('/design_map_ai/api/getmap/' + this.$route.query.mapid)

      if (response.data.status.returnCode !== 0 || (Array.isArray(response.data.result.map) && response.data.result.map.length === 0)) {
        this.$router.push('NotFound')
        return
      }
      const res = response.data.result.map

      this.mapType = res.mapType
      this.mapStyle = res.mapStyle
      this.zoom = res.zoomLevel
      this.lat = res.centerLat
      this.lng = res.centerLng

      await this.drawMap()
    },
    navigateToTitle () {
      this.$router.push({ name: 'Title' })
    }
  }
}
</script>

<style scoped>
.header {
  position: absolute;
  z-index: 10;
  cursor: pointer;
  bottom: 20px;
  right: 0;
}

.header img{
  width: 100%;
}

.map-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

#ZMap {
  height: 100%;
  width: 100%;
  /* width: calc(100% - 480px); */
  margin: 0 auto;
  /* max-width:none; */
}

.hidden {
  visibility: hidden;
}

.copyright {
  position: absolute;
  bottom: 0px;
  right: 10px;
  color: #fff;
  background-color: #333;
  padding: 0 5px;
  border-radius: 4px;
  font-size: 10px;
  font-family: Arial, sans-serif;
  display: flex;
  gap: 10px;

  z-index: 100;
  cursor: pointer;
}

.copyright a {
  color: #fff;
  text-decoration: none;
}

.copyright a:hover {
  text-decoration: underline;
}

</style>
